import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@systemeio/components';
import { HelpCircleIcon } from '@systemeio/icons';
import { centsToUnits } from '@systemeio/util';
import { useAffiliateDashboardInvoices } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-invoices';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardInvoicesInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-invoices-interface';
import { InvoiceStateEnum, InvoiceStateTitle } from 'modules/payment/invoices/enums/invoice-state-enum';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'shared/components';
import ListingLayout from 'shared/components/listing-layout';
import { RelativeTime } from 'shared/components/relative-time';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useDidUpdateEffect } from 'shared/hooks/use-did-update-effect';
import { useDownloadInvoiceLink } from 'shared/hooks/use-download-invoice-link';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { currencyFormat } from 'shared/utils/currency-format';
import { InvoiceDetailsModal } from '../../payment/invoices/components/invoice-details-modal';
interface AffiliateDashboardInvoicesProps {
  mainFilter: AffiliateDashboardFilterInterface;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardInvoices = t0 => {
  const $ = _c(66);
  const {
    mainFilter,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const router = useRouter();
  const purchaseInvoiceId = router.query.purchaseInvoiceId as string;
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    setFirstPage
  } = usePagination(true);
  const [invoiceId, setInvoiceId] = useState(null);
  let t1;
  let t2;
  if ($[0] !== purchaseInvoiceId) {
    t1 = () => {
      if (!isNaN(Number(purchaseInvoiceId))) {
        setInvoiceId(Number(purchaseInvoiceId));
      }
    };
    t2 = [purchaseInvoiceId];
    $[0] = purchaseInvoiceId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const getDownloadInvoiceLink = useDownloadInvoiceLink();
  let t3;
  if ($[3] !== limit || $[4] !== mainFilter || $[5] !== pagination) {
    t3 = {
      filter: mainFilter,
      pagination,
      limit
    };
    $[3] = limit;
    $[4] = mainFilter;
    $[5] = pagination;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    affiliateInvoices,
    counter
  } = useAffiliateDashboardInvoices(t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setInvoiceId(null);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const closeModal = t4;
  let t5;
  if ($[8] !== setFirstPage) {
    t5 = () => {
      setFirstPage();
    };
    $[8] = setFirstPage;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== mainFilter || $[11] !== setFirstPage) {
    t6 = [setFirstPage, mainFilter];
    $[10] = mainFilter;
    $[11] = setFirstPage;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useDidUpdateEffect(t5, t6);
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.affiliate.amount");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== setMainFilter || $[16] !== user?.dashboardLocale) {
    t8 = invoice => <div className="flex items-center gap-1.5">{invoice.user.affiliateProgramBrandName ? <Tooltip label={invoice.user.affiliateProgramBrandName} mode="hover"><button onClick={() => setMainFilter(prev => ({
          ...prev,
          vendorId: invoice.user.id
        }))} className="focus-visible:focus-ring-primary shrink-0 rounded-full outline-hidden"><Avatar size="md" alt={invoice.user.affiliateProgramBrandName} src={invoice.user.avatar} displayName={invoice.user.affiliateProgramBrandName} email={invoice.user.email} /></button></Tooltip> : <button onClick={() => setMainFilter(prev_0 => ({
        ...prev_0,
        vendorId: invoice.user.id
      }))} className="focus-visible:focus-ring-primary shrink-0 rounded-full outline-hidden"><Avatar size="md" alt={invoice.user.affiliateProgramBrandName} src={invoice.user.avatar} displayName={invoice.user.affiliateProgramBrandName} email={invoice.user.email} /></button>}<span>{currencyFormat(centsToUnits(invoice.invoice.amount), invoice.invoice.currency, user?.dashboardLocale)}</span></div>;
    $[15] = setMainFilter;
    $[16] = user?.dashboardLocale;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      key: "amount",
      header: t7,
      widthPercent: 30,
      onRender: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("dashboard.affiliate.state.label");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = invoice_0 => <div className="flex gap-1"><span>{t(InvoiceStateTitle[invoice_0.invoice.state])}</span>{invoice_0.invoice.state === InvoiceStateEnum.unpaid && <Button aria-label={t("global.help")} onClick={() => {
        setInvoiceId(invoice_0.id);
      }} size="icon-xs" variant="ghost-color"><HelpCircleIcon /></Button>}</div>;
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = {
      key: "state",
      header: t10,
      widthPercent: 50,
      onRender: t11
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("global.date");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = {
      key: "date",
      header: t13,
      widthPercent: 20,
      onRender: _temp
    };
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t12 || $[33] !== t14 || $[34] !== t9) {
    t15 = [t9, t12, t14];
    $[32] = t12;
    $[33] = t14;
    $[34] = t9;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const columns = t15;
  let t16;
  if ($[36] !== t) {
    t16 = t("dashboard.affiliate.invoices");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("dashboard.affiliate.download_invoice");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== getDownloadInvoiceLink) {
    t18 = invoice_2 => getDownloadInvoiceLink(invoice_2.id);
    $[40] = getDownloadInvoiceLink;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t17 || $[43] !== t18) {
    t19 = {
      openLink: [{
        caption: t17,
        name: "download-invoice",
        openInNew: true,
        setHref: t18
      }]
    };
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== limit || $[46] !== setLimit) {
    t20 = {
      limit,
      setLimit
    };
    $[45] = limit;
    $[46] = setLimit;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== pagination || $[49] !== setPagination) {
    t21 = {
      pagination,
      setPagination
    };
    $[48] = pagination;
    $[49] = setPagination;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== affiliateInvoices || $[52] !== columns || $[53] !== t19 || $[54] !== t20 || $[55] !== t21) {
    t22 = <Table actions={t19} data={affiliateInvoices} columns={columns} limiter={t20} paginator={t21} />;
    $[51] = affiliateInvoices;
    $[52] = columns;
    $[53] = t19;
    $[54] = t20;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== counter || $[58] !== t16 || $[59] !== t22) {
    t23 = <ListingLayout counter={counter} title={t16}>{t22}</ListingLayout>;
    $[57] = counter;
    $[58] = t16;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== invoiceId) {
    t24 = <InvoiceDetailsModal invoiceId={invoiceId} onCloseModal={closeModal} />;
    $[61] = invoiceId;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== t23 || $[64] !== t24) {
    t25 = <>{t23}{t24}</>;
    $[63] = t23;
    $[64] = t24;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  return t25;
};
export default AffiliateDashboardInvoices;
function _temp(invoice_1) {
  return <span className="w-full truncate"><RelativeTime time={invoice_1.invoice.date} /></span>;
}